// ============================================= //
//                                               //
//              1checkout.js v4                  //
//                                               //
// ============================================= //

// ---------------------- UTIL FUNCTIONS ---------------------- //
class OneCheckoutUtil {

  constructor() {
    this.URL_PARAMS = new URLSearchParams(window.location.search);
  };

  apiRequest(method, url, headers, data, success, error, complete=null) {
    var xhttp = new XMLHttpRequest();
    xhttp.open(method, url, true);
    headers.forEach(header => {
      xhttp.setRequestHeader(header[0], header[1]);
    });
    xhttp.onreadystatechange = function () {
      if (xhttp.readyState === 4) {
        if (xhttp.status === 200) {
          success(JSON.parse(this.responseText));
        } else {
          try{
            if (error.length > 1) { // Check if the error callback expects a status parameter
              error(JSON.parse(this.responseText), xhttp.status);
            } else {
                error(JSON.parse(this.responseText));
            }
          }catch(parseError){
            console.log(parseError);
            if (error.length > 1) {
              error({}, xhttp.status);
            } else {
              error();
            }
          }
        };
        if (complete) {
          complete();
        };
      };
    };
    xhttp.send(JSON.stringify(data));
  };

  set1CheckoutLocalStorage(key, value, expiry_hrs) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry_hrs*60*60*1000));
    expires = expires.toUTCString();

    localStorage.setItem(key, JSON.stringify({
      value: value,
      expires: expires}));
  };

  get1CheckoutLocalStorage(key) {
    try {
      var _data = JSON.parse(localStorage.getItem(key));
      var now = (new Date()).getTime();
      var expires = Date.parse(_data.expires);
      
      if (expires > now) {
        return _data.value;
      } else {
        this.delete1CheckoutLocalStorage(key);
        return null;
      }
    } catch (err) {
      return null;
    };
  };

  delete1CheckoutLocalStorage(key) {
    localStorage.removeItem(key);
  };

  get1CheckoutCookie(key) {
    for (var o = key + "=", r = decodeURIComponent(document.cookie).split(";"), n = 0; n < r.length; n++) {
      for (var t = r[n];
        " " == t.charAt(0);) t = t.substring(1);
      if (0 == t.indexOf(o)) return t.substring(o.length, t.length)
    };
    return null;
  };

  getAllParams(){
    var url = new URL(window.location.href);

    var queryParams = url.searchParams;
    
    var params = {};

    queryParams.forEach(function (value, key) {
      params[key] = value;
    });

    if (queryParams.toString() !== "") {
      let existingParams = this.get1CheckoutLocalStorage('queryparams_1c')
      this.set1CheckoutLocalStorage('queryparams_1c', {...existingParams, ...params}, 24*7);
    } else {
      params = this.get1CheckoutLocalStorage('queryparams_1c');
    }

    return params || {};
  };

};
// ---------------------- UTIL FUNCTIONS ---------------------- //

// ---------------------- CONSTANTS ---------------------- //
const ONE_CHECKOUT_UTIL = new OneCheckoutUtil();
const IS_DEMO_1C_PAGE = false;
const API_HOST_1C = 'https://api.1checkout.ai';
const HOST_1C = 'https://pay.1checkout.ai';
const API_KEY_1C = '3fe4648b-c938-49f5-9cd9-b2825cd4fe12';
const IS_1C_ENABLED = !ONE_CHECKOUT_UTIL.get1CheckoutLocalStorage('d1c') && true;
// ---------------------- CONSTANTS ---------------------- //

// ---------------------- AUTO DETECTION OF BUTTON ---------------------- //
class OneCheckoutBtnRenderer {

  constructor(targetBtns, logMutations=false) {
    if (IS_1C_ENABLED)
      this.targetBtns = targetBtns;
    else
      this.targetBtns = [];
    
    this.logMutations = logMutations;

    // Remove btnMeta if not applicable for current page
    var pageObserverRequired = false;
    var _tempTargetBtnsFor1C = [];
    this.targetBtns.forEach(btnMeta => {
      if (btnMeta.urlPattern) {
        if (window.location.pathname.includes(btnMeta.urlPattern))
          _tempTargetBtnsFor1C.push(btnMeta);
      } else {
        _tempTargetBtnsFor1C.push(btnMeta);
      };
    });
    this.targetBtns = _tempTargetBtnsFor1C;

    this.targetBtns.forEach(btnMeta => {
      // Hide all static targets before page loads
      this.hide1CTarget(btnMeta);
      // Check if page observer will be required
      if (btnMeta.pageObserver) pageObserverRequired = true;
    });

    // Create all button observers
    this.BTN_OBSERVERS = [];
    this._obsConfig = { childList: true, subtree: true };
    this._obsCallback = (mutationsList, observer) => {
      // Fetch the btnMeta for observer
      var _btnMeta;
      var _observer;
      this.BTN_OBSERVERS.forEach(o => {
        if (o.observer == observer) {
          _btnMeta = o.btnMeta;
          _observer = o.observer;
        };
      });
      // Check for all mutations and replace the button
      for (var mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (this.logMutations)
              console.log(node);
            if (node.nodeName == _btnMeta.observeForBtn.nodeName && node.getAttribute(_btnMeta.observeForBtn.nodeAttr) == _btnMeta.observeForBtn.nodeAttrVal) {
              this.hide1CTarget(_btnMeta, node);
              this.render1CBtn(_btnMeta, node);
              if (_btnMeta.observeForBtn.stopObservingWhenFound) _observer.disconnect();
              return;
            };
          });
        };
      };
    };

    // Create all url observers
    this.targetBtns.forEach(btnMeta => {
      if (btnMeta.observeUrl) this.initUrlObserver(btnMeta);
    });
    
    // Create all button observers
    this.targetBtns.forEach(btnMeta => {
      if (btnMeta.observeForBtn) this.initBtnObserver(btnMeta);
    });

    // Create all pagination observers
    this.paginationObserver;
    if (pageObserverRequired) this.initPageObserver();
  };

  hide1CTarget(btnMeta, container=null) {
    if (container) {
      if (btnMeta.hideInstead) {
        var el = container.querySelector(btnMeta.hideInstead);
      } else {
        var el = container.querySelector(btnMeta.selector);
      };
    } else {
      if (btnMeta.hideInstead) {
        var el = document.querySelector(btnMeta.hideInstead);
      } else {
        var el = document.querySelector(btnMeta.selector);
      };
    };
    if (el) el.classList.add('dc-none');
  };
  
  render1CBtn(btnMeta, container=null) {
    if (container) {
      var btn = container.querySelector(btnMeta.selector);
    } else {
      var btn = document.querySelector(btnMeta.selector);
    };
    if (btn) {
      // Return if 1C already added
      if (container) {
        if (container.getElementsByClassName('btn-group-1checkout').length > 0) return;
      } else {
        if (btn.parentElement.getElementsByClassName('btn-group-1checkout').length > 0) return;
      };
      // Else add as a sibling of target
      var checkoutBtnContainer = document.createElement('div');
      checkoutBtnContainer.setAttribute('class', 'btn-group-1checkout');
      checkoutBtnContainer.innerHTML = btnMeta.dynamicBtn;
      if(btnMeta.siblingPosition == "before"){
        btn.before(checkoutBtnContainer);  
      }else{
        btn.after(checkoutBtnContainer);
      }
    };
  };
  
  initBtnObserver(btnMeta) {
    var observer = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    if (observer) {
      var containers = document.querySelectorAll(btnMeta.observeForBtn.container);
      containers.forEach(container => {
        var _observer = new observer(this._obsCallback);
        _observer.observe(container, this._obsConfig);
        this.BTN_OBSERVERS.push({
          btnMeta: btnMeta,
          observer: _observer
        });
      });
    };
  };

  initUrlObserver(btnMeta) {
    var observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.initiatorType === "fetch") {
          if (entry.name.includes(btnMeta.observeUrl)) {
            this.hide1CTarget(btnMeta);
            this.render1CBtn(btnMeta);
          };
        };
      };
    });
  
    observer.observe({
      entryTypes: ["resource"]
    });
  };
  
  initPageObserver() {
    this.paginationObserver = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.initiatorType === "fetch") {
          if (entry.name.includes('page=')) {
            this.targetBtns.forEach(btnMeta => {
              if (btnMeta.observeForBtn) this.initBtnObserver(btnMeta);
  
              if (btnMeta.observeEvent) {
                var targets = document.querySelectorAll(btnMeta.observeEvent.target);
                targets.forEach(target => {
                  target.addEventListener(btnMeta.observeEvent.event, function() {
                    this.hide1CTarget(btnMeta);
                    this.render1CBtn(btnMeta);
                  });
                });
              };
            });
          };
        };
      };
    });
  
    this.paginationObserver.observe({
      entryTypes: ["resource"]
    });
  };

  pageLoad() {
    // On page load, dynamically add 1Checkout btns which need not be observed
    this.targetBtns.forEach(btnMeta => {
      this.render1CBtn(btnMeta);

      if (btnMeta.observeEvent) {
        var targets = document.querySelectorAll(btnMeta.observeEvent.target);
        targets.forEach(target => {
          target.addEventListener(btnMeta.observeEvent.event, function() {
            oneCheckoutBtnRenderer.hide1CTarget(btnMeta);
            oneCheckoutBtnRenderer.render1CBtn(btnMeta);
          });
        });
      };
    });
  };

};
// ---------------------- AUTO DETECTION OF BUTTON ---------------------- //

// ---------------------- RENDER 1CHECKOUT BUTTON ---------------------- //
class OneCheckout {

  constructor() {
    // --- VARIABLES & CONSTS
    this.CHECKOUT_CLIENT_IP_ADDRESS = null;
    try {
      fetch('https://api64.ipify.org?format=json')
        .then((response) => response.json())
        .then((data) => {
          try {
            this.CHECKOUT_CLIENT_IP_ADDRESS = data.ip
          } catch (error) {};
        });
    } catch (error) {};
    this.API_HEADERS = [
      ['Content-type', 'application/json'],
      ['X-LOGISY-API-KEY', API_KEY_1C]
    ];
    this.CHECKOUT_ID;
    // var VISITOR_COUNTRY_CODE = null;
    this.TRIGGER_1CHECKOUT = ONE_CHECKOUT_UTIL.URL_PARAMS.get('t1c');
    this.TRIGGER_1CHECKOUT = this.TRIGGER_1CHECKOUT && this.TRIGGER_1CHECKOUT.toLowerCase() == 'true' && IS_1C_ENABLED;
    this.REFRESH_CART = ONE_CHECKOUT_UTIL.URL_PARAMS.get('refresh');
    this.REFRESH_CART = this.REFRESH_CART && this.REFRESH_CART.toLowerCase() == 'true';
    this.CHECKOUT_CART = {
      getCartItemCount: function() {
        var count = 0;
        this.CHECKOUT_CART.items.forEach(item => {
          count += item.quantity;
        });
        return count;
      },
      getCartItemDetails: function() {
        var items = [];
        this.CHECKOUT_CART.items.forEach(item => {
          items.push({
            id: item.id.toString(),
            quantity: item.quantity,
            name: item.title
          });
        });
        return items;
      },
      getCartProductIds: function() {
        var ids = [];
        this.CHECKOUT_CART.items.forEach(item => {
          ids.push(item.product_id.toString());
        });
        return ids;
      }
    };

    this.loaderMessages1Checkout = [
      'Carefully wrapping your items',
      'Crossing T’s & dotting I’s',
      'Juuust a moment..',
      'Adding the cherry on top'
    ];
    this.loaderMessagesTimer = null;
    this._messageIdx = 0;
    this.CHECKOUT_URL;
    this.CHECKOUT_ERROR = false;

    this.QUERY_PARAMS_1C = ONE_CHECKOUT_UTIL.getAllParams();

    // --- EXTERNAL TRIGGERS
    if (this.TRIGGER_1CHECKOUT) {
      // Showing overlay here but 1checkout triggered after cart is updated
      // document.body.style.overflow = 'hidden';
      var loader = '<span style="position: absolute; border: 3px solid #fff; border-top: 3px solid #0000; border-radius: 50%; width: 32px; height: 32px; left: calc(50% - 16px); top: calc(50% - 16px)"></span>';
      var overlay = `<div id="checkoutRedirectOverlay" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; background-color: rgba(0,0,0,0.9); z-index: 1063;">${loader}<p style="position: absolute;left: calc(50% - 75px);top: 53%;color: white;">Loading your cart items..... </p></div>`;
      document.querySelector('body').innerHTML += overlay;
      document.querySelector('#checkoutRedirectOverlay span').animate(
        [{transform: `rotate(360deg)`}],
        {
          duration: 1000,
          iterations: Infinity
        });
      // document.getElementById('checkoutModal').checked = true;
      // document.querySelector('.checkout-progressbar').classList.remove('dc-none');
      // this.startLoaderMessages();
    };
    if (!this.TRIGGER_1CHECKOUT && this.REFRESH_CART) {
      // Show only overlay till cart is updated and page is refreshed
      var loader = '<span style="position: absolute; border: 3px solid #fff; border-top: 3px solid #0000; border-radius: 50%; width: 32px; height: 32px; left: calc(50% - 16px); top: calc(50% - 16px)"></span>';
      var overlay = `<div id="checkoutRedirectOverlay" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; background-color: rgba(0,0,0,0.9); z-index: 1063;">${loader}</div>`
      document.querySelector('body').innerHTML += overlay;
      document.querySelector('#checkoutRedirectOverlay span').animate(
        [{transform: `rotate(360deg)`}],
        {
          duration: 1000,
          iterations: Infinity
        });
    };
  };

  startLoaderMessages() {
    this.loaderMessagesTimer = setInterval(function() {
      document.getElementById('checkoutLoadingMessage').innerHTML = oneCheckout.loaderMessages1Checkout[oneCheckout._messageIdx];
      oneCheckout._messageIdx += 1;
      if (oneCheckout._messageIdx == oneCheckout.loaderMessages1Checkout.length) {
        oneCheckout.resetSplashScreen();
      };
    }, 2000);
  };

  resetSplashScreen() {
    // Reset splash screen
    clearInterval(this.loaderMessagesTimer);
    this._messageIdx = 0;
    document.getElementById('checkoutLoadingMessage').innerHTML = 'Initializing...';
    document.querySelector('.checkout-progressbar').classList.add('dc-none');
  };

  //--- Overriding buy now button
  addOneItemAfterAnotherToCart(items, unaddedItems, checkoutData) {
    var item = items.pop();
    if (item) {
      ONE_CHECKOUT_UTIL.apiRequest(
        'POST', '/cart/add.js',
        [['Content-type', 'application/json; charset=UTF-8']],
        {
          'items': [item]
        },
        function(data) {
        },
        function(err) {
          unaddedItems.push(err.description);
        },
        function() {
          oneCheckout.addOneItemAfterAnotherToCart(items, unaddedItems, checkoutData); 
        });
    } else {
      if (unaddedItems.length > 0) {
        unaddedItemsHtml = '';
        unaddedItems.forEach(item => {
          unaddedItemsHtml += `<li style="text-align: left;">${item}</li>`;
        })
        var title = '<h3 style="text-align: center; color: #404143;">Oops!</h3>';
        var message = `<div style="text-align: center; color: #404143;"><ul style="max-height: 118px;overflow-y: auto;">${unaddedItemsHtml}</ul></div>`;
        var goHomeLink = `<a href="/cart" style="margin-top: 16px;background-color: #404143;color: #fff;padding: 8px 46px;border-radius: 4px;text-decoration: none;">Ok</a>`;
        var style = 'position: absolute; display: flex; flex-direction: column; align-items: center;';
        style += 'width: 350px; left: calc(50% - 175px); top: 30%;';
        style += 'background-color: #fff; border-radius: 4px; padding: 16px;';
        var showError = `<div style="${style}">${title}${message}${goHomeLink}</div>`;
        document.getElementById('checkoutRedirectOverlay').innerHTML = showError;
      } else {
        if (this.TRIGGER_1CHECKOUT) {
          // var _data = {showError: false};
          document.getElementById('checkoutRedirectOverlay').remove();
          document.querySelector('.checkout-progressbar').classList.remove('dc-none');
          this.startLoaderMessages();
          // try {
          //   _data["phone"] = checkoutData.user_phone_number;
          // } catch (err) {}
          // _data["checkout_type"] = "checkout";
          document.getElementById('checkoutModal').checked = true;
          // this.initCheckoutIframe(_data);
          // const iframe = document.querySelector('.checkoutmodal .iframe-container iframe');
          // const notesInput = document.getElementById("Note") || null;
          // iframe.onload = function(){
          //   iframe.contentWindow.postMessage({checkout_id: checkoutData.checkout_id, checkout_url: checkoutData.checkout_url, notes: notesInput!==null && notesInput.value, topic: '1CHECKOUTDATA'}, '*');
          //   oneCheckout.checkoutLoaded();
          // }
        } else if (this.REFRESH_CART) {
          window.location.replace('/cart');
        };
      };
    };
  };

  // Trigger WA 1Commerce flow
  triggerWA1CheckoutOnPageLoad() {
    if (['/cart', '/cart/'].includes(window.location.pathname) && this.REFRESH_CART) {
      this.CHECKOUT_ID = ONE_CHECKOUT_UTIL.URL_PARAMS.get('cid');
      if (this.CHECKOUT_ID) {
        // Fetch the checkout info from server
        ONE_CHECKOUT_UTIL.apiRequest(
          'GET', `${API_HOST_1C}/checkouts/${this.CHECKOUT_ID}`,
          this.API_HEADERS,
          {},
          function(checkoutData) {
            // Clear the cart
            oneCheckout.initCheckoutIframe({showError: false, checkout_type: "checkout", phone: checkoutData.user_phone_number});
            const iframe = document.querySelector('.checkoutmodal .iframe-container iframe');
            const notesInput = document.getElementById("Note") || null;
            console.log(iframe);
            if(iframe){
              iframe.onload = function(){
                iframe.contentWindow.postMessage({checkout_id: checkoutData.checkout_id, checkout_url: checkoutData.checkout_url, notes: notesInput!==null && notesInput.value, topic: '1CHECKOUTDATA'}, '*');
                oneCheckout.checkoutLoaded();
              }
            }else{
              setTimeout(()=>{
               iframe.onload = function(){
                  iframe.contentWindow.postMessage({checkout_id: checkoutData.checkout_id, checkout_url: checkoutData.checkout_url, notes: notesInput!==null && notesInput.value, topic: '1CHECKOUTDATA'}, '*');
                  oneCheckout.checkoutLoaded();
               }
              }, 3000)
            }
            ONE_CHECKOUT_UTIL.apiRequest(
              'GET', '/cart/clear.js',
              [['Content-type', 'application/json; charset=UTF-8']],
              {},
              function(data) {
                var items = [];
                checkoutData.cart.items.forEach(item => {
                  items.push({
                    'id': item.variant_id,
                    'quantity': item.quantity});
                });
                var unaddedItems = [];
                oneCheckout.addOneItemAfterAnotherToCart(items, unaddedItems, checkoutData);
              },
              function(err) {
              },
              function() {
              });
          },
          function(err) {
            console.log(err);  // TODO
          });
      };
    };
  };

  // Toggle enable/disable 1Checkout btn when a separate variant is selected
  checkVariantAvailability(variantId) {
    try {
      var productHandle = document.getElementById('productHandle1Checkout').value;
      if (productHandle) {
        ONE_CHECKOUT_UTIL.apiRequest(
          'GET', `/products/${productHandle}.js`,
          [['Content-type', 'application/json; charset=UTF-8']],
          {},
          function(data) {
            var variantAvailable = true;
            data.variants.forEach(variant => {
              if (variant.id == variantId) {
                variantAvailable = variant.available;
              };
            });
            if (!variantAvailable) {
              document.getElementById('buyNow1CheckoutBtn').disabled = true;
            } else {
              document.getElementById('buyNow1CheckoutBtn').disabled = false; 
            };
          },
          function(err) {
          });
      } else {
        document.getElementById('buyNow1CheckoutBtn').disabled = false;
      };
      document.getElementById('buyNow1CheckoutError').classList.add('dc-none');
    } catch (err) {}
  };

  checkoutModalToggled(el) {
    if (el.checked == true){
      document.querySelector('.checkout-progressbar').classList.remove('dc-none');
      this.startLoaderMessages();
      document.body.style.overflow = 'hidden';
      // this.startAnimation();
      this.initialize1Checkout();
    } else {
      document.body.style.overflow = null;
    };
  };
  
  triggerShopifyCheckout(el){
    el.disabled = true;
    el.querySelector('.btn-1checkout-title').classList.add('dc-none');
    el.querySelector('.btn-1checkout-sub-title').classList.add('dc-none');
    el.querySelector('.btn-1checkout-spinner').classList.remove('dc-none');
    ONE_CHECKOUT_UTIL.apiRequest(
      'GET', '/cart.json',
      [['Content-type', 'application/json']],
      {},
      function(cartJson) {
        window.location.href= `${window.location.origin}/checkouts/cn/${cartJson.token}/information`;
        setTimeout(()=>{
          el.disabled = false;
          el.querySelector('.btn-1checkout-title').classList.remove('dc-none');
          el.querySelector('.btn-1checkout-sub-title').classList.remove('dc-none');
          el.querySelector('.btn-1checkout-spinner').classList.add('dc-none');
        }, 4000)
      }
    )
  }

  trigger1Checkout(el) {
    var giftCardElement = document.getElementById('1cGiftCard');
    if((giftCardElement && giftCardElement !== null && giftCardElement.checked)){
      this.triggerShopifyCheckout(el);
    }else if(this.CHECKOUT_ERROR){
      ONE_CHECKOUT_UTIL.apiRequest(
        'POST', 'https://n8n.solidwebhook.com/webhook/issue-1c',
        [{"Content-Type": "application/json"}],
        {"location": window.location.href, "error": "Merchant not active"},
        function(data){},
        function(err){},
      )
      this.triggerShopifyCheckout(el);
    }else{
      var initCheckbox = document.getElementById('checkoutModal');
      initCheckbox.checked = true;
      this.checkoutModalToggled(initCheckbox);
    }
  };
  
  // buyNow1CheckoutBtn click
  buyNow1Checkout(el) {
    document.getElementById('buyNow1CheckoutError').classList.add('dc-none');
    el.disabled = true;
    el.querySelector('.btn-1checkout-title').classList.add('dc-none');
    el.querySelector('.btn-1checkout-sub-title').classList.add('dc-none');
    el.querySelector('.btn-1checkout-spinner').classList.remove('dc-none');
  
    try {
      var variantId = el.closest('form').querySelector('[name="id"]').value;
    } catch (error) {
      var variantId = document.querySelector('[name="id"]').value;
    };
    try {
      try {
        var quantity = el.closest('form').querySelector('[name="quantity"]').value;
      } catch (error) {
        var quantity = document.querySelector('[name="quantity"]').value;
      };
    } catch (error) {
      var quantity = 1;
    };
    
    var properties = {};
    document.querySelectorAll('[name*="properties["]').forEach(el => {
      var propKey = el.getAttribute('name');
      propKey = propKey.match(/\[(.*)\]/i);
      if (propKey.length > 1) {
        properties[propKey[1]] = el.value;
      };
    });

    ONE_CHECKOUT_UTIL.apiRequest(
      'GET', '/cart/clear.js',
      [['Content-type', 'application/json; charset=UTF-8']],
      {},
      function(data) {
        ONE_CHECKOUT_UTIL.apiRequest(
          'POST', '/cart/add.js',
          [['Content-type', 'application/json; charset=UTF-8']],
          {
            'items': [
              {
                'id': variantId,
                'quantity': quantity,
                'properties': properties
              }
            ]
          },
          function(data) {
            if(oneCheckout.CHECKOUT_ERROR){
              ONE_CHECKOUT_UTIL.apiRequest(
                'POST', 'https://n8n.solidwebhook.com/webhook/issue-1c',
                [{"Content-Type": "application/json"}],
                {"location": window.location.href, "error": "Merchant not active"},
                function(data){},
                function(err){},
              )
              oneCheckout.triggerShopifyCheckout(el);
            } else {
              // Trigger 1checkout modal
              document.getElementById('checkoutModal').click();
              // Trigger cart update JS event
              document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: variantId,
                  quantity: quantity
                }
              }));
            }
          },
          function(err) {
            if (err.description) {
              document.getElementById('buyNow1CheckoutError').innerHTML = err.description;
            };
            document.getElementById('buyNow1CheckoutError').classList.remove('dc-none');
          });
      },
      function(err) {
      },
      function() {
        if(!oneCheckout.CHECKOUT_ERROR){
          el.querySelector('.btn-1checkout-title').classList.remove('dc-none');
          el.querySelector('.btn-1checkout-sub-title').classList.remove('dc-none');
          el.querySelector('.btn-1checkout-spinner').classList.add('dc-none');
          el.disabled = false;
        }
      });
  };
  
  // Initializing 1Checkout popup
  initialize1Checkout() {
    if (IS_DEMO_1C_PAGE) {
      this.CHECKOUT_CART = {...this.CHECKOUT_CART, ...fakeCart};
      // Create a fake checkout object
      ONE_CHECKOUT_UTIL.apiRequest(
        'POST', `${API_HOST_1C}/create`,
        this.API_HEADERS,
        this.CHECKOUT_CART,
        function(data) {
          oneCheckout.CHECKOUT_ID = data.checkout_id;
          oneCheckout.CHECKOUT_URL = data.checkout_url;
          const iframe = document.querySelector('.checkoutmodal .iframe-container iframe');
          if (iframe) {
            try {
              iframe.contentWindow.postMessage({checkout_id: data.checkout_id, checkout_url: data.checkout_url, notes: null, topic: '1CHECKOUTDATA'}, '*')
            } catch (err) {
                console.error("Error posting message to iframe:", err);
                const errDetails = {
                  "location": window.location.href,
                  "error": "Error posting message to Iframe",
                  ...err,
                  ...oneCheckout.CHECKOUT_CART
                }
                ONE_CHECKOUT_UTIL.apiRequest(
                  'POST', 'https://n8n.solidwebhook.com/webhook/issue-1c',
                  [{"Content-Type": "application/json"}],
                  errDetails,
                  function(data){},
                  function(err){},
                )
            }
          } else {
              oneCheckout.initCheckoutIframe({ showError: false, checkout_type: "checkout" });
              try {
                iframe.contentWindow.postMessage({checkout_id: data.checkout_id, checkout_url: data.checkout_url, notes: null, topic: '1CHECKOUTDATA'}, '*')
              } catch (err) {
                // const errDetails = {
                //   "location": window.location.href,
                //   "error": "Error posting message to Iframe twice",
                //   ...err,
                //   ...oneCheckout.CHECKOUT_CART
                // }
                // ONE_CHECKOUT_UTIL.apiRequest(
                //   'POST', 'https://n8n.solidwebhook.com/webhook/issue-1c',
                //   [{"Content-Type": "application/json"}],
                //   errDetails,
                //   function(data){},
                //   function(err){},
                // )
              }
          }
        },
        function(err) {
          console.log(err);  // TODO
          oneCheckout.initCheckoutIframe({showError: true, checkout_type: "checkout"});
        });
    } else {
      // Get the cart json
      ONE_CHECKOUT_UTIL.apiRequest(
        'GET', '/cart.json',
        [['Content-type', 'application/json']],
        {},
        function(cartJson) {
          if(cartJson.item_count > 0){
            const districtInput = document.getElementById("district");
            const clubNameInput = document.getElementById("club-name");
            const notesInput = document.getElementById("Note") || null;

            if (districtInput) {
              oneCheckout.CHECKOUT_CART = { ...oneCheckout.CHECKOUT_CART, "district": districtInput.value };
            }

            if (clubNameInput) {
              oneCheckout.CHECKOUT_CART = { ...oneCheckout.CHECKOUT_CART, "club_name": clubNameInput.value };
            }
            oneCheckout.CHECKOUT_CART = {...oneCheckout.CHECKOUT_CART, ...cartJson};
            // Create checkout object
            ONE_CHECKOUT_UTIL.apiRequest(
              'POST', `${API_HOST_1C}/create`,
              oneCheckout.API_HEADERS,
              oneCheckout.CHECKOUT_CART,
              function(data) {
                oneCheckout.CHECKOUT_ID = data.checkout_id;
                oneCheckout.CHECKOUT_URL = data.checkout_url;
                const iframe = document.querySelector('.checkoutmodal .iframe-container iframe');
                if(iframe){
                  try {
                    iframe.contentWindow.postMessage({checkout_id: data.checkout_id, checkout_url: data.checkout_url, notes: notesInput !== null && notesInput.value, topic: '1CHECKOUTDATA'}, '*')
                  } catch(err){
                    const errDetails = {
                      "location": window.location.href,
                      "error": "Error posting to Iframe", 
                      ...err,
                      ...oneCheckout.CHECKOUT_CART
                    }
                    ONE_CHECKOUT_UTIL.apiRequest(
                      'POST', 'https://n8n.solidwebhook.com/webhook/issue-1c',
                      [{"Content-Type": "application/json"}],
                      errDetails,
                      function(data){},
                      function(err){},
                    )
                  }
                } else {
                  oneCheckout.initCheckoutIframe({ showError: false, checkout_type: "checkout" });
                  try {
                    iframe.contentWindow.postMessage({checkout_id: data.checkout_id, checkout_url: data.checkout_url, notes: notesInput !== null && notesInput.value, topic: '1CHECKOUTDATA'}, '*')
                  } catch(err) {
                    // const errDetails = {
                    //   "location": window.location.href,
                    //   "error": "Error posting to Iframe twice",
                    //   ...err,
                    //   ...oneCheckout.CHECKOUT_CART
                    // }
                    // ONE_CHECKOUT_UTIL.apiRequest(
                    //   'POST', 'https://n8n.solidwebhook.com/webhook/issue-1c',
                    //   [{"Content-Type": "application/json"}],
                    //   errDetails,
                    //   function(data){},
                    //   function(err){},
                    // )
                  }
                }
                // oneCheckout.initCheckoutIframe({showError: false});
              },
              function(err, status) {
                const headers = oneCheckout.API_HEADERS.reduce((acc, [key, value]) => {
                  acc[key] = value;
                  return acc;
                }, {});
                const errDetails = {
                  "location": window.location.href,
                  "error": "Create api error", 
                  ...err,
                  ...oneCheckout.CHECKOUT_CART, 
                  ...headers,
                  status
                }
                ONE_CHECKOUT_UTIL.apiRequest(
                  'POST', 'https://n8n.solidwebhook.com/webhook/issue-1c',
                  [{"Content-Type": "application/json"}],
                  errDetails,
                  function(data){},
                  function(err){},
                )
                setTimeout(()=>{
                  window.location.href= `${window.location.origin}/checkouts/cn/${cartJson.token}/information`;
                }, 500)
                oneCheckout.initCheckoutIframe({showError: true, checkout_type: "checkout"});
              }
            );
          } else {
            oneCheckout.initCheckoutIframe({showError: false, cartError: true, checkout_type: "checkout"});
          }
        },
        function(err) {
          console.log(err);  // TODO
          oneCheckout.initCheckoutIframe({showError: true, checkout_type: "checkout"});
        });
    };
  };
  
  initCheckoutIframe(params) {
    params['containerheight'] = document.querySelector('.checkoutmodal .inner').offsetHeight;
    // params['checkoutid'] = this.CHECKOUT_ID;
    // params['checkouturl'] = this.CHECKOUT_URL;
    params['apikey'] = API_KEY_1C;
    params['discount'] = ONE_CHECKOUT_UTIL.URL_PARAMS.get('discount');
  
    var iframeUrl = new URL(`${HOST_1C}/v4/checkout/widget/`);
    Object.keys(params).forEach(key => {
      if (params[key] !== null) {
        iframeUrl.searchParams.set(key.toLowerCase(), params[key]);
      };
    });
  
    // Populate fb pixel from cookie
    var fbclid = ONE_CHECKOUT_UTIL.get1CheckoutCookie('_fbc');
    if (fbclid) {
      iframeUrl.searchParams.set('fbclid', fbclid);
    };
  
    // Populate IP address
    if (this.CHECKOUT_CLIENT_IP_ADDRESS) {
      iframeUrl.searchParams.set('ip', this.CHECKOUT_CLIENT_IP_ADDRESS);
    };

    // Populate all query params
    Object.keys(this.QUERY_PARAMS_1C).forEach(key => {
      iframeUrl.searchParams.set(key, this.QUERY_PARAMS_1C[key]);
    });

    // Populate fb pixel from cookie
    var fbp = ONE_CHECKOUT_UTIL.get1CheckoutCookie('_fbp');
    if (fbp) {
      iframeUrl.searchParams.set('fbp', fbp);
    };

    // Populate ga token from cookie
    var ga = ONE_CHECKOUT_UTIL.get1CheckoutCookie('_ga');
    if (ga) {
      iframeUrl.searchParams.set('ga', ga);
    };
  
    // Populate the page url
    iframeUrl.searchParams.set('url', encodeURI(window.location.href));

    const scriptElement = document.querySelector('script[src*="https://svc.nitrocommerce.ai/"]');

    function callNitroApi(token, parent_id, nitro_id){
      ONE_CHECKOUT_UTIL.apiRequest(
        'POST', `${API_HOST_1C}/ntro/find`,
        oneCheckout.API_HEADERS,
        {
          token,
          parent_id,
          nitro_id,
        },
        function(data) {
          if(data?.data?.phone !== null){
            iframeUrl.searchParams.set('nitro_phone', data?.data?.phone);
          }
          if (params['checkout_type'] == "checkout") {
            document.querySelector('.checkoutmodal .iframe-container').innerHTML = `<iframe src="${iframeUrl.href}" onload="oneCheckout.checkoutLoaded()" name="oneCheckoutIframe" class="dc-none"></iframe>`;
          }
        },
        function(err){
          console.log(err);
          if (params['checkout_type'] == "checkout") {
            document.querySelector('.checkoutmodal .iframe-container').innerHTML = `<iframe src="${iframeUrl.href}" onload="oneCheckout.checkoutLoaded()" name="oneCheckoutIframe" class="dc-none"></iframe>`;
          }
        }
      );
    }

    let retryCount = 0; // Initialize a counter

    // Function to call nitro.ready
    function callNitroReady() {
        if (typeof nitro !== 'undefined' && typeof nitro.ready === 'function') {
          nitro.ready(function(token, parent, nitro_id) {
            if(token !== null && parent !== null && nitro_id !== null){
              callNitroApi(token, parent, nitro_id);
            } else if (retryCount < 15) {
              retryCount++;
              setTimeout(callNitroReady, 200); // Retry after 200ms
            } else {
              console.log("Maximum retry attempts reached. Executing fallback action...");
              document.querySelector('.checkoutmodal .iframe-container').innerHTML = `<iframe src="${iframeUrl.href}" onload="oneCheckout.checkoutLoaded()" name="oneCheckoutIframe" class="dc-none"></iframe>`;
            }
          });
        } else if (retryCount < 15) {
          retryCount++;
          console.log("nitro.ready is not available yet, retrying...");
          setTimeout(callNitroReady, 200); // Retry after 200ms
        } else {
          console.log("Maximum retry attempts reached. Executing fallback action...");
          document.querySelector('.checkoutmodal .iframe-container').innerHTML = `<iframe src="${iframeUrl.href}" onload="oneCheckout.checkoutLoaded()" name="oneCheckoutIframe" class="dc-none"></iframe>`;
        }
    }

    if (scriptElement) {
      if (scriptElement.onload) {
        setTimeout(callNitroReady, 500);
      } else {
        scriptElement.onload = function() {
          setTimeout(callNitroReady, 500);
        };
      }
    } else {
      console.log('Script element not found.');
      if (params['checkout_type'] == "checkout") {
        document.querySelector('.checkoutmodal .iframe-container').innerHTML = `<iframe src="${iframeUrl.href}" onload="oneCheckout.checkoutLoaded()" name="oneCheckoutIframe" class="dc-none"></iframe>`;
      }
    }
  };
  
  exitLoaderAnimation(){
    const animatedDiv = document.querySelector('.checkoutmodal .splash-screen');
    const animatedText = document.querySelector('.checkout-progressbar p');

    animatedText.style.color = '#fff';

    animatedDiv.animate([ { opacity: 1 }, { opacity: 0 }], { duration: 700 })

    setTimeout(()=>{
      document.querySelector('.checkoutmodal .splash-screen').classList.add('dc-none');
    }, 700)
  }

  checkoutLoaded() {
    var iframe = document.querySelector('.checkoutmodal iframe');
    iframe.classList.remove('dc-none');

    const notesInput = document.getElementById("Note") || null;

    // this.exitLoaderAnimation();
    document.querySelector('.checkoutmodal .splash-screen').classList.add('dc-none');
    this.resetSplashScreen();

    if(this.CHECKOUT_ID && this.CHECKOUT_URL){
      iframe.contentWindow.postMessage({checkout_id: this.CHECKOUT_ID, checkout_url: this.CHECKOUT_URL, notes: notesInput !==null && notesInput.value, topic: '1CHECKOUTDATA'}, '*')
      // Trigger fb pixel event
      try {
        fbq('track', 'InitiateCheckout', {
          content_type: 'product_group',
          content_ids: this.CHECKOUT_CART.getCartProductIds(),
          value: parseFloat((this.CHECKOUT_CART.total_price / 100).toFixed(2)),
          contents: this.CHECKOUT_CART.getCartItemDetails(),
          num_items: this.CHECKOUT_CART.getCartItemCount(),
          currency: this.CHECKOUT_CART.currency});
      } catch (e) {
        console.warn('fbq error for "InitiateCheckout"', e);
      };
      // Trigger ga event
      try {
        ga('send', {
          hitType: 'event',
          eventCategory: 'ecommerce',
          eventAction: 'begin_checkout',
          eventLabel: '1checkout'});
      } catch (e) {
        console.warn('ga error for "InitiateCheckout"', e);
      };
    }
  };

  // Function to start the animation
  startAnimation() {
    const animatedDiv = document.querySelector('.bounce-loader');

    // Reset the animation
    animatedDiv.style.animation = 'none';
    animatedDiv.offsetHeight; // Trigger a reflow, resetting the animation
    animatedDiv.style.animation = 'bounce-anim 3s forwards 100ms'; // Start the bounce animation
  }

  messageListener(event) {
    if (event.origin == HOST_1C) {
      if (event.data.topic == '1CHECKOUT') {
        if (event.data.message == 'launch_truecaller') {
          document.location = event.data.truecallerDeeplink;
        } else if (event.data.message == 'exit_checkout') {
          document.querySelector('.checkoutmodal .overlay').classList.add('dc-none');
          document.querySelector('.checkoutmodal .splash-screen').classList.remove('dc-none');
          document.getElementById('checkoutModal').click();
          document.querySelector('.checkoutmodal iframe').remove();

          this.initCheckoutIframe({showError: false, checkout_type: "checkout"});
          
          if (event.data.fallback) {
            // Disable 1C for 4 hours
            ONE_CHECKOUT_UTIL.set1CheckoutLocalStorage('d1c', true, 4);
          };
          if (event.data.nextPage) {
            window.location.replace(event.data.nextPage);
          };
          // If 1checkout was loaded from WA commerce, refresh on exit to refresh the cart UI
          this.CHECKOUT_ID = ONE_CHECKOUT_UTIL.URL_PARAMS.get('cid');
          
          if (this.CHECKOUT_ID && this.TRIGGER_1CHECKOUT) {
            window.location.replace(`/cart?cid=${this.CHECKOUT_ID}&t1c=false&refresh=false`);
          };
        } else if (event.data.message == 'clear_cart') {
          ONE_CHECKOUT_UTIL.apiRequest(
            'POST', '/cart/clear.js',
            [['Content-type', 'application/json; charset=UTF-8']],
            {},
            function(data) {
            },
            function(err) {
            });
        } else if (event.data.message == 'launch_upi_app') {
          document.location = event.data.deeplink;
        } else if (event.data.message == 'otp_verified') {
          try {
            fbq('track', 'CompleteRegistration', {
              content_type: 'product_group',
              content_ids: event.data.cartProductIds,
              value: event.data.totalCartValue,
              contents: event.data.cartItemDetails,
              num_items: event.data.cartItemCount,
              currency: event.data.currency,
              event_id: event.data.event_id,
            });
          } catch (e) {
            console.warn('fbq error for "CompleteRegistration"', e);
          };
        } else if (event.data.message == 'payment_initiated') {
          try {
            fbq('track', 'AddPaymentInfo', {
              content_type: 'product_group',
              content_ids: event.data.cartProductIds,
              value: event.data.totalCartValue,
              contents: event.data.cartItemDetails,
              num_items: event.data.cartItemCount,
              currency: event.data.currency,
              event_id: event.data.event_id,
            });
          } catch (e) {
            console.warn('fbq error for "AddPaymentInfo"', e);
          };
        } else if (event.data.message == 'order_placed') {
          try {
            fbq('track', 'Purchase', { 
              content_type: 'product_group',
              content_ids: event.data.cartProductIds,
              value: event.data.totalCartValue,
              contents: event.data.cartItemDetails,
              num_items: event.data.cartItemCount,
              currency: event.data.currency,
              event_id: event.data.event_id,
            });
          } catch (e) {
            console.warn('fbq error for "Purchase"', e);
          };
        } else if (event.data.message == 'checkout_conversion') {
          // Delete UTM params and send fbq and ga
          try{
            gtag('event', 'conversion', {
              'send_to': event.data.send_to_key,
              'value': event.data.totalCartValue,
              'currency': 'INR',
              'transaction_id': event.data.orderId,
            });
          }catch(err){}
          try {
            ga('send', {
              hitType: 'event',
              eventCategory: 'ecommerce',
              eventAction: 'purchase',
              eventLabel: '1checkout',
              eventValue: event.data.totalCartValue});
            ga('require', 'ecommerce');
            ga('ecommerce:addTransaction', {
              'id': event.data.orderId,
              'affiliation': '1checkout',
              'revenue': event.data.totalCartValue,
              'shipping': event.data.shippingCharges,
              'tax': event.data.totalTax
            });
            event.data.cartItemDetails.forEach(item => {
              ga('ecommerce:addItem', {
                'id': item.id,
                'name': item.name,
                'sku': item.sku,
                'category': '',
                'price': item.price,
                'quantity': item.quantity
              });
            });
            ga('ecommerce:send');
          } catch (e) {
            console.warn('ga error for "Purchase"', e);
          };
        } else if (event.data.message == 'create_abandoned_checkout') {
          // try {
          //   fetch(event.data.checkoutUrl)
          //     .then(response => {});
          // } catch (error) {};

          try {
            const iframe = document.createElement("iframe");
            iframe.style.display = "none"; // Hide the iframe
            iframe.src = event.data.checkoutUrl;
            iframe.id = "acIframe"
            document.body.appendChild(iframe);
          } catch (error) {
              console.error("Error loading iframe:", error);
          }
        } else if(event.data.message == "to_collect_ga_ids"){
          let ga_measurement_id = event.data.ga_measurement_id;
          var ga_client_id;
          var ga_session_id;

          // Get client ID
          gtag('get', ga_measurement_id, 'client_id', (id) => {
            ga_client_id = id;

            // Get session ID
            gtag('get', ga_measurement_id, 'session_id', (id) => {
              ga_session_id = id;

              // Send IDs to iframe
              const iframe = document.querySelector('.checkoutmodal .iframe-container iframe');
              iframe.contentWindow.postMessage({ ga_client_id, ga_session_id, topic: '1CHECKOUTGADATA'}, '*');
            });
          });
        } else if(event.data.message == 'redirect_to_shopify_checkout'){
          this.CHECKOUT_ERROR = true;
        } else if(event.data.message == 'order_url_redirection'){
          window.location.replace(event.data.nextPage);
        } else if(event.data.message === 'open_razorpay'){
          function loadRazorpayModal(){
            const updatedConfig = { 
              ...event.data.rzpConfig, 
              handler: function (data) {
                  const iframe = document.querySelector('.checkoutmodal .iframe-container iframe');
                  
                  // Ensure iframe exists before posting message
                  if (iframe?.contentWindow) {
                      iframe.contentWindow.postMessage({ topic: 'RAZORPAYSUCCESS' }, '*');
                  } else {
                      console.log("Iframe not found or inaccessible.");
                  }
          
                  // Clear cart using API request
                  ONE_CHECKOUT_UTIL.apiRequest(
                      'POST', 
                      '/cart/clear.js',
                      [['Content-Type', 'application/json; charset=UTF-8']], // Fix capitalization
                      {},
                      () => console.log("Cart cleared successfully."),
                      (err) => console.log("Error clearing cart:", err)
                  );
              }
            };
            const razorpay = new Razorpay(updatedConfig)
              .on("payment.failed", function (data) {
                iframe.contentWindow.postMessage({topic: 'RAZORPAYFAILURE'});
              })
              .on("payment.error", function (data) {
                iframe.contentWindow.postMessage({topic: 'RAZORPAYFAILURE'});
              });

            razorpay.open();
          }

          if (document.querySelector('script[src="https://checkout.razorpay.com/v1/checkout.js"]')) {
            console.log("Razorpay script already loaded.");
            loadRazorpayModal();
            return;
          }
      
          const script = document.createElement("script");
          script.src = "https://checkout.razorpay.com/v1/checkout.js";
          script.async = true;
          script.onload = function () {
              console.log("Razorpay script loaded successfully.");
              loadRazorpayModal();
          };
      
          script.onerror = function () {
              console.error("Failed to load Razorpay script.");
          };
      
          document.body.appendChild(script);
        }
      } else if (event.data.closeIframe) {
        let iframeUrlElem = document.querySelector(".checkoutmodal .iframe-container iframe");
        let url = new URL(iframeUrlElem.src);
        url.searchParams.set("payment_success", "failure");
        url.searchParams.set("pg_mode", "snapmint");
        iframeUrlElem.src = url;
      };
    };
  };

  pageLoad() {
    this.triggerWA1CheckoutOnPageLoad();

    // Registering event for availability check 
    try {
      document.querySelector('[name="id"]').addEventListener('change', function() {
        oneCheckout.checkVariantAvailability(parseInt(this.value));
      });
    } catch(e) {};

    var checkout_type = "checkout";
    
    if (['/cart', '/cart/'].includes(window.location.pathname) && this.REFRESH_CART) {
      checkout_type = "wa_checkout";
    }

    this.initCheckoutIframe({showError: false, checkout_type: checkout_type});
  };

  variantChanged(event) {
    oneCheckout.checkVariantAvailability(event.detail.variant.id);
  };

};
// ---------------------- RENDER 1CHECKOUT BUTTON ---------------------- //
// ---------------------- AUTO DETECTION OF BUTTON ---------------------- //
var TARGET_BTNS_FOR_1C = [
  {
    target: 'cart_button',
    selector: '#checkout',
    hideInstead: 'None',
    siblingPosition: 'before',
    dynamicBtn: `
      <button id="buyNow1CheckoutBtn" type="button" class="btn-1checkout btn-1checkout-style" onclick="oneCheckout.trigger1Checkout(this)">
        <span class="btn-1checkout-title">Check Out</span>
        <span class="btn-1checkout-sub-title"></span>
        <span class="btn-1checkout-spinner dc-none"></span>
      </button>`
  },
  {
    target: 'cart_drawer_checkout_button',
    selector: 'cart-drawer-buttons-block a',
    hideInstead: 'None',
    observeForBtn: {
      container: 'body',
      nodeName: 'DIV'
    },
    dynamicBtn: `
      <button id="buyNow1CheckoutBtn" type="button" class="btn-1checkout btn-1checkout-style" onclick="oneCheckout.trigger1Checkout(this)">
        <span class="btn-1checkout-title">Check out</span>
        <span class="btn-1checkout-sub-title"></span>
        <span class="btn-1checkout-spinner dc-none"></span>
      </button>`
  },
  {
    target: 'cart_drawer_checkout_button',
    selector: '#CartDrawer-Checkout',
    hideInstead: 'None',
    siblingPosition: 'before',
    observeForBtn: {
      container: 'body',
      nodeName: 'DIV'
    },
    dynamicBtn: `
      <button id="buyNow1CheckoutBtn" type="button" class="btn-1checkout btn-1checkout-style" onclick="oneCheckout.trigger1Checkout(this)">
        <span class="btn-1checkout-title">Check out</span>
        <span class="btn-1checkout-sub-title"></span>
        <span class="btn-1checkout-spinner dc-none"></span>
      </button>`
  },
  {
    target: 'buy_now_button',
    selector: 'form[action="/cart/add"] div[data-shopify="payment-button"]',
    observeForBtn: {
      container: 'body',
      nodeName: 'DIV'
    },
    dynamicBtn: `
      <button id="buyNow1CheckoutBtn" type="button" class="btn-1checkout btn-1checkout-style" onclick="oneCheckout.buyNow1Checkout(this)" style="margin-bottom: 10px;">
        <span class="btn-1checkout-title">Buy it now</span>
        <span class="btn-1checkout-sub-title"></span>
        <span class="btn-1checkout-spinner dc-none"></span>
      </button>
      <span id="buyNow1CheckoutError" class="dc-none">This item seems to be out of stock!</span>`
  },
  {
    target: 'quick_view_buy_now_button',
    selector: 'form[action="/cart/add"] div[data-shopify="payment-button"]',
    hideInstead: 'None',
    siblingPosition: 'before',
    observeForBtn: {
      container: 'body',
      nodeName: 'DIV',
      nodeAttr: 'class',
      nodeAttrVal: 'product product--small product--left product--columns product--mobile-show grid grid--1-col grid--2-col-tablet'
    },
    dynamicBtn: `
      <button id="buyNow1CheckoutBtn" type="button" class="btn-1checkout btn-1checkout-style" onclick="oneCheckout.buyNow1Checkout(this)" style="margin-bottom: 10px;">
        <span class="btn-1checkout-title">Buy it now</span>
        <span class="btn-1checkout-sub-title"></span>
        <span class="btn-1checkout-spinner dc-none"></span>
      </button>
      <span id="buyNow1CheckoutError" class="dc-none">This item seems to be out of stock!</span>`
  }
];

var oneCheckoutBtnRenderer = new OneCheckoutBtnRenderer(
  targetBtns=TARGET_BTNS_FOR_1C)
  
oneCheckoutBtnRenderer.pageLoad();

document.querySelector('body').onload = function() {
  oneCheckoutBtnRenderer.pageLoad();
};
// ---------------------- AUTO DETECTION OF BUTTON ---------------------- //


// ---------------------- RENDER 1CHECKOUT BUTTON ---------------------- //
var oneCheckout = new OneCheckout();

// Browser messaging
window.addEventListener('message', function(event) {
  oneCheckout.messageListener(event);
}, false);

history.pushState(null, null, window.location.href);
const iframeUrlDiv = document.querySelector(".checkoutmodal .iframe-container");
const checkoutmodalInput = document.querySelector(".checkoutmodal-state");

window.addEventListener('popstate', function(e){
  if(iframeUrlDiv && iframeUrlDiv !== null && iframeUrlDiv.childNodes.length > 0 && iframeUrlDiv.childNodes[0].nodeName === "IFRAME"){
    if(checkoutmodalInput.checked){
      history.go(1);
      iframeUrlDiv.childNodes[0].contentWindow.postMessage({topic: "back-button-detection"}, "*");
    }else{
      history.go(-1);
    }
  }else{
    history.go(-1);
  }
}, false);

window.addEventListener('load', function() {
  oneCheckout.pageLoad();
});

// Registering optional event for availability check 
document.addEventListener('variant:changed', function(event) {
  oneCheckout.variantChanged(event);
});

function checkoutModalToggled(el) {
  oneCheckout.checkoutModalToggled(el);
};
// ---------------------- RENDER 1CHECKOUT BUTTON ---------------------- //